<ng-container *transloco="let t; prefix: 'transaction_list'">
  <div class="overflow-x-auto max-h-[50vh] rounded-box my-0">
    <!-- @if (
      statusFilter() !== transactionStatus.ALL || accountsFilter() !== "all"
    ) {
      <p class="text-sm p-2 italic">
        {{ transactions().length }}
        <span>
          {{ t("records_found") }}
        </span>
      </p>
    } -->
    @if (transactions().length) {
      <table class="table table-pin-rows">
        <!-- head -->
        <thead class="dark:text-slate-300 hidden md:table-header-group">
          <tr class="bg-stone-50 dark:bg-base-100 uppercase">
            <th></th>
            <th>{{ t("date") }}</th>
            <th>{{ t("customer") }}</th>
            <th>{{ t("amount") }}</th>
            <th>{{ t("status") }}</th>
            <th>{{ t("account") }}</th>
          </tr>
        </thead>
        <tbody>
          @for (
            transaction of transactions()
              | transactionStatusFilter: statusFilter()
              | transactionAccountFilter: accountsFilter();
            track $index;
            let count = $count
          ) {
            <!-- rows -->
            <tr
              (click)="showTransaction(transaction)"
              class="even:dark:bg-base-100 odd:dark:bg-base-200 even:bg-base-200 odd:bg-white cursor-pointer md:hover:!bg-base-300 hover:!bg-base-200"
            >
              <th class="hidden md:table-cell">
                <i class="fa-light text-3xl md:text-2xl fa-circle-user"></i>
                <!-- <div class="rounded-full w-9 h-9">
                    <img src="/assets/icons/flags/RW.svg" class="" alt="" />
                  </div> -->
              </th>
              <td class="hidden md:table-cell first-letter:uppercase">
                {{ transaction.date_created! | readableTime }}
              </td>
              <td
                class="md:table-cell md:gap-0 flex gap-2 px-3 py-2 pr-0 md:p-[1rem]"
              >
                <i
                  class="fa-light text-3xl md:text-2xl fa-circle-user md:hidden block"
                ></i>
                <span class="flex flex-col justify-center items-start">
                  <span *transloco="let t">{{
                    transaction.sender || t("customer")
                  }}</span>
                  <span
                    class="text-[0.64rem] text-neutral-500 md:hidden block first-letter:uppercase"
                  >
                    {{ transaction.date_created! | readableTime }}
                  </span>
                </span>
              </td>
              <td>
                <span
                  class="font-semibold md:font-normal text-md flex w-full justify-end md:justify-start gap-1 items-center"
                >
                  <div
                    class="badge size-[0.5rem] p-0 md:hidden"
                    [ngClass]="{
                      'bg-slate-500 size-[0.7rem]':
                        transaction.status == transactionStatus.INITIATED,
                      'badge-warning':
                        transaction.status == transactionStatus.PENDING,
                      'badge-success':
                        transaction.status == transactionStatus.CONFIRMED,
                      'bg-slate-400 dark:bg-slate-800':
                        transaction.status == transactionStatus.CANCELED,
                    }"
                  ></div>
                  {{ transaction.amount | number: "1.0-2" }}
                  {{ $any(transaction.country)?.currency }}
                </span>
              </td>
              <td class="hidden md:table-cell">
                <div
                  class="badge text-white uppercase text-xs"
                  [ngClass]="{
                    'bg-slate-500':
                      transaction.status == transactionStatus.INITIATED,
                    'badge-warning':
                      transaction.status == transactionStatus.PENDING,
                    'badge-success':
                      transaction.status == transactionStatus.CONFIRMED,
                    'bg-slate-400 dark:bg-slate-800':
                      transaction.status == transactionStatus.CANCELED,
                  }"
                  *transloco="let t; prefix: 'transaction_status'"
                >
                  {{ t(transaction?.status!) }}
                </div>
              </td>
              <td class="hidden md:table-cell">
                @if (transaction.receiver_account) {
                  @if ($any(transaction.receiver_account)?.label) {
                    {{ $any(transaction.receiver_account)?.label }}
                  } @else {
                    {{
                      $any($any(transaction.receiver_account)?.payment_provider)
                        ?.name
                    }}
                    ({{ $any(transaction.receiver_account)?.number_display }})
                  }
                } @else {
                  <span class="text-warning"> {{ t("no_account") }}</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
    @for (
      transaction of transactions()
        | transactionStatusFilter: statusFilter()
        | transactionAccountFilter: accountsFilter();
      track $index;
      let count = $count
    ) {
    } @empty {
      @if (!loading()) {
        <div
          class="flex flex-col items-center justify-center gap-2 rounded-box m-4 px-4 py-2 border-dashed border border-neutral-400 text-neutral-400 text-center"
        >
          <i class="fa-light fa-xmark-to-slot text-3xl"></i>
          <p class="text-md mt-1">{{ t("no_transactions") }}</p>
        </div>
      } @else {
        <div
          class="flex items-center justify-center gap-2 rounded-box px-4 py-2 text-neutral-400 text-center w-full"
        >
          <span class="loading loading-spinner w-9"></span>
        </div>
      }
    }
  </div>
</ng-container>

<qwiko-transaction-details
  [transaction]="selectedTransaction()"
  [loading]="loading()"
></qwiko-transaction-details>
